// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare var require: any;
export const environment = {
  production: false,
  appID: 2,
  appUUID: '93a7b19d-bf89-470e-84b5-870294dd218d',
  appPackageName: 'com.aspevo.itraceapp',
  apiHostUrl: 'https://django-itrace-1059606892232.asia-southeast1.run.app/api/',
  projectId: 17,
  projectFix: true,
  pageConfig: {
    size: 10,
    options: [10, 25, 50],
    count: 0,
    index: 0,
    showFirstLastButtons: false
  },
  maxBytesFileUpload: 50000000,
  auth: {
    clientID: 'pfPVevj7N6yS16MhZmvXYIvmUfHeyUdJxLO5Chg0',
    username: 'admin@itrace.com',
    password: '123456aB!'
  },
  // Google reCAPTCHA site keys for login (public; the secret keys live only in the backend,
  // in the app's meta.captcha). v3 runs invisibly; v2 is the checkbox fallback.
  recaptcha: {
    v3SiteKey: '6LfWRvYtAAAAAPMljB0MaV-AVCRJBjI3jdiZzGfv',
    v2SiteKey: '6LffRvYtAAAAAGorf2PqI_nppzEAEuzDIXD5LfmU',
    v3Action: 'login',
  },
  firebase: {
    apiKey: "AIzaSyBudyLGQwd_lcCkfZ8EOyXZWNLxJYn6kHA",
    authDomain: "itrace-9961e.firebaseapp.com",
    projectId: "itrace-9961e",
    storageBucket: "itrace-9961e.firebasestorage.app",
    messagingSenderId: "350681489393",
    appId: "1:350681489393:web:1607275e15053fc7f72e50",
    measurementId: "G-S73C1B1G74"
  },
  appVersion: require('../../package.json').version + '-dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
